import { render, staticRenderFns } from "./TutorItem.vue?vue&type=template&id=1604bf1b&scoped=true&"
import script from "./TutorItem.vue?vue&type=script&lang=js&"
export * from "./TutorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1604bf1b",
  null
  
)

export default component.exports